import { render, staticRenderFns } from "./examination_home_manage.vue?vue&type=template&id=48a0a73e&scoped=true&"
import script from "./examination_home_manage.js?vue&type=script&lang=js&"
export * from "./examination_home_manage.js?vue&type=script&lang=js&"
import style0 from "./examination_home_manage.css?vue&type=style&index=0&id=48a0a73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0a73e",
  null
  
)

export default component.exports